
export enum EditorTool {
  ARROW,
  FREEHAND,
  SHAPE,
  MEASURE,
  TEXT
}

export enum EditorArrowTool {
  ARROW_LEFT,
  ARROW_UP,
  ARROW_RIGHT,
  ARROW_BOTTOM,
  ARROW_CLOCKWISE,
  ARROW_ANTICLOCKWISE,
}

export enum EditorShapeTool {
  SHAPE_CIRCLE,
  SHAPE_RECTANGLE,
  SHAPE_LINE,
}

export enum EditorMeasureTool {
  MEASURE_CIRCLE,
  MEASURE_RECTANGLE,
  MEASURE_LINE,
}

export const EditorTextSizeScalingFactor = 15;
export enum EditorTextSizeTool {
  TEXT_SMALL,
  TEXT_MEDIUM,
  TEXT_BIG,
}

export enum EditorToolWidth {
  THIN,
  LIGHT,
  REGULAR,
  MEDIUM,
  BOLD
}

export enum EditorToolColor {
  RED = '#FF0000',
  YELLOW = '#FFFF00',
  GREEN = '#00FF00',
  CYAN = '#00FFFF',
  BLUE = '#0000FF',
  BLACK = '#000000'
}

export enum EditorSelectionPanel {
  SUBTOOL,
  COLOR,
  WIDTH
}
